<template lang="pug">
  v-card(flat style="min-width: 45%")
    v-row.my-2(no-gutters)
      v-col.py-1.shrink.mr-3
        v-img(:src="parentProduct.image ? parentProduct.image.file : require('@/assets/image_placeholder.png')" width="56px" aspect-ratio="1")
      v-col.py-3
        div.p1.basic800--text.mb-1 {{ parentProduct.name }}
        div.c2.basic600--text.product-description.mb-1 {{ parentProduct.price | displayPrice }}
</template>

<script>
export default {
  name: 'ProductCardDisplay',
  props: {
    parentProduct: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
</style>